// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"48bb1c04","717":"fd45310e","787":"5a7e10e2","872":"84e87c32"}[chunkId] + ".chunk.js";
};